jQuery(document).ready(function () {
    var footer = {

        wrapper: jQuery('footer'),
        content: jQuery('.footer-content'),
        scrolling: false,

        set_footer_height: function () {

            var wrapper_height = footer.wrapper.outerHeight();
            var content_height = footer.content.outerHeight();
            var window_height = jQuery(window).height();
            var wrapper_offset = footer.wrapper.offset().top;
            // log(content_height);

            if ((wrapper_height >= content_height) && (window_height - wrapper_offset >= content_height)) {
                footer.wrapper.css({'height': window_height - wrapper_offset + "px"});
                // log("setting height to: " + (window_height - wrapper_offset) + "px");
            } else {
                footer.wrapper.css({'height': content_height + "px"});
                // log("setting height to content height.");
            }
        },

        resize_footer: function () {
            if (this.wrapper && !this.scrolling) {
                this.scrolling = true;
                setTimeout(function () {
                    footer.set_footer_height();
                    footer.scrolling = false;
                }, 100)
            }
        }
    };

    if (footer.wrapper.length) {
        footer.set_footer_height();

        jQuery(window).resize(function () {
            footer.resize_footer();
        });
    }
});




// WEBPACK FOOTER //
// ./private/js/footer.js